import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import categories from './categories'
import cities from './cities'
import countries from './countries'
import districts from './districts'
import industries from './industries'
import levels from './levels'
import plugins from './plugins'
import programs from './programs'
import proxies from './proxies'
import regions from './regions'
import settings from './settings'
import sources from './sources'
import spiderListSelectionModule from './spider-list-selection'
import spiders from './spiders'
import statuses from './statuses'
import users from './users'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    spiders,
    sources,
    industries,
    categories,
    levels,
    countries,
    regions,
    districts,
    cities,
    statuses,
    plugins,
    users,
    settings,
    programs,
    proxies,
    'spider-list-selection': spiderListSelectionModule,
  },
})
